import { savingsPlansForTableLoadingSelector } from "@/store/commitments/selectors/coverage-and-utilization/data/loading/savingsPlansForTableLoadingSelector";
import { reservationsForTableLoadingSelector } from "@/store/commitments/selectors/reservations/data/loading/reservationsForTableLoadingSelector";
import { savingsPlansForGranularLoadingSelector } from "@/store/commitments/selectors/coverage-and-utilization/data/loading/savingsPlansForGranularLoadingSelector";
import { reservationsForGranularLoadingSelector } from "@/store/commitments/selectors/reservations/data/loading/reservationsForGranularLoadingSelector";
import { overviewLoadingSelector } from "@/store/commitments/selectors/overview/loading/overviewLoadingSelector";
import { RootState } from "@/store/store";

export const commitmentPageLoadingSelector = (state: RootState) => {
  const savingsPlansTableDataLoading =
    savingsPlansForTableLoadingSelector(state);
  const reservationsTableDataLoading =
    reservationsForTableLoadingSelector(state);
  const savingsPlansGranularDataLoading =
    savingsPlansForGranularLoadingSelector(state);
  const reservationsGranularDataLoading =
    reservationsForGranularLoadingSelector(state);
  const overviewDataLoading = overviewLoadingSelector(state);
  return (
    savingsPlansTableDataLoading ||
    reservationsTableDataLoading ||
    savingsPlansGranularDataLoading ||
    reservationsGranularDataLoading ||
    overviewDataLoading
  );
};
